import React from 'react'
import logo from '../assets/gtcoLogo.png'

const Header = () => {
    return (
        <div className="flex justify-between items-start w-full">
            <div
                className=" relative bg-[#dd4f05] w-full sm:w-[60%] h-[5vh] -skew-x-[30deg] flex items-center justify-start lg:px-10">
                <div className="block absolute -left-5 right-5 -inset-0 skew-x-[30deg] bg-[#dd4f05]"
                     aria-hidden="true"></div>
                <h1 className="relative text-white text-sm lg:text-xl skew-x-[30deg] font-medium text-left px-4">GTB Ghana
                    Card Account Linking</h1>
            </div>

            <div className="flex flex-col space-y-2 sm:w-[40%] items-end px-4">
                <img src={logo} className="h-16 w-16 lg:h-16 lg:w-16 object-contain hidden sm:block" alt="logo"/>
                <small className="hidden md:block text-slate-600">Guaranty Trust Bank (Ghana) Ltd</small>
            </div>
        </div>
    )
}

export default Header
